import { Navigate } from 'react-router-dom';
import { useFeature } from '@/contexts/FeatureFlagContext';
import { FeatureFlags } from '@/types/feature-flags.types';

interface FeatureRouteProps {
  feature: keyof FeatureFlags;
  children: React.ReactNode;
  redirectTo?: string;
}

export function FeatureRoute({
  feature,
  children,
  redirectTo = '/dashboard',
}: FeatureRouteProps) {
  const isEnabled = useFeature(feature);

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
